// Config pública de la app Web de Firebase (mismo proyecto que
// firebase-service-account.json / google-services.json de Android, pero con
// sus propias credenciales de cliente). NO son secretos: Firebase espera que
// este objeto viaje al navegador, la seguridad real la da la consola de
// Firebase (restricciones de dominio/API) y las reglas del backend.
//
// Hay que rellenar estas variables en client/.env.development y
// client/.env.production tras crear la "Web app" en la consola de Firebase
// (ver guía en el chat). Mientras VITE_FIREBASE_API_KEY esté vacío, el push
// web queda desactivado sin romper nada (usePushNotifications.js de
// Capacitor sigue funcionando igual para la app móvil).
export const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || ''
}

export const FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY || ''

export const isFirebaseWebConfigured = Boolean(firebaseConfig.apiKey && FIREBASE_VAPID_KEY)

let firebaseApp = null
let messagingInstance = null

// Devuelve la instancia de Firebase Messaging del navegador, o null si no
// está configurado o el navegador no soporta Service Workers/push (Safari
// viejo, navegación privada estricta, etc.)
export const getFirebaseMessaging = async () => {
    if (!isFirebaseWebConfigured) return null

    if (!messagingInstance) {
        const { initializeApp, getApps, getApp } = await import('firebase/app')
        const { getMessaging, isSupported } = await import('firebase/messaging')

        if (!(await isSupported())) return null

        firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig)
        messagingInstance = getMessaging(firebaseApp)
    }

    return messagingInstance
}
